
import { common } from '@tencent/ceiba-base-components';
const openUrl = (url, target = '_self') => {
  try {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = url;
      return;
    }
    const newTab = window.open('', target);
    newTab.opener = null;
    newTab.location = url;
  } catch (error) {
    console.error('openUrl fail, err=', error);
    window.location.href = url;
  }
};

function getLoginStatusUrl(url, roleInfo) {
  const accType = common.tool.getCookie('acctype') || '';
  const openId = common.tool.getCookie('openid') || '';
  const appId = common.tool.getCookie('appid') || '';
  const accessToken = common.tool.getCookie('access_token') || '';

  let params = {
    scpOpenId: openId,
    scpToken: accessToken,
    scpAppId: appId,
    scpAccType: accType,
    from: encodeURIComponent(window.location.href)
  }

  if (roleInfo && roleInfo.role_id) {
    Object.assign(params, {
      scpRoleId: roleInfo.role_id,
      scpAreaId: roleInfo.area_id,
      scpPartitionId: roleInfo.partition_id,
      scpPlatId: roleInfo.plat_id,
      scpRoleName: encodeURIComponent(common.tool.Base64.decode(roleInfo.role_name)),
      scpPartitionName: encodeURIComponent(common.tool.Base64.decode(roleInfo.partition_name))
    });
  }


  const queryStrings = [];
  for (const key in params) {
    const value = params[key];
    queryStrings.push(`${key}=${value}`);
  }
  const queryPath = `${url}${url.includes('?') ? '&' : '?'
    }${queryStrings.join('&')}`;
  return queryPath;
}

const openerPlugin = {
  install(Vue) {
    Vue.prototype.$openerSupercorePlugin = {
      getOpenViewSchema: async (params) => {
        return [
          {
            key: 'needLogin',
            name: '校验登录',
            type: 'select',
            default: 0,
            options: [
              {
                label: '无需登录也可跳转',
                value: 0
              },
              {
                label: '登录后方可跳转',
                value: 1
              }
            ],
            hidden: false,
          },
          {
            key: 'loginToken',
            name: '携带登录态',
            type: 'select',
            default: '',
            options: [
              {
                label: '无',
                value: ''
              },
              {
                label: '尊享商城登录态',
                value: 'zunxiangToken'
              }
            ],
            hidden: (context) => {
              return context.payload.needLogin !== 1
            },
          },
        ]
      },
      openView: async (params, store) => {
        const payload = params.payload || {}
        let toLink
        // 拿到配置是否登录的状态
        if (payload.needLogin === 1) {
          // 用户登录成功用户信息不为空对象即登录状态
          if (store.isLogin) {
            // 在用户登录情况下，当需要携带登录态跳转时
            if (payload.loginToken === 'zunxiangToken') {

              toLink = getLoginStatusUrl(params.url, store.roleInfo);
            } else {
              // 在用户登录情况下，不需要携带登录态跳转时
              toLink = params.url;

            }

          } else {
            Vue.prototype.alert('请登录后进行操作')
            return
          }
        } else {
          toLink = params.url;
        }
        openUrl(toLink, params.target);
      }
    };
  },
};

export default openerPlugin;
